{
  "install": {
    "aria": "BidNova アプリをインストール",
    "title": "BidNova をインストール",
    "body": "ホーム画面に追加すると、入札も通知もすぐに届きます。",
    "iosBody": "「共有」をタップし、「ホーム画面に追加」を選択するとインストールできます。",
    "iosHint": "共有 → ホーム画面に追加",
    "action": "アプリをインストール",
    "later": "後で",
    "dismiss": "インストール案内を閉じる"
  },
  "offline": {
    "title": "オフラインです",
    "body": "ライブ入札には接続が必要です。復旧すると自動的に再接続します。"
  }
}
